<template>
  <List :archive="1"></List>
</template>

<script>
import List from './index.vue'

export default {
  components: {
    List,
  },
}
</script>